import Collection from './collection.js';
export default Collection;
